/* LTHR tap to zoom in the product photo viewer (LSC-155, 2026-10-02).
   Clarity 9/30-10/2: phone shoppers opened the photo viewer, then tapped the
   Woodward photo over and over (170 dead taps, 14 rage clicks) wanting a
   closer look at the basket weave. Dawn's viewer does nothing on a tap
   (a mouse click closes it, which stays as is), and on phones it opened each
   photo as a cropped 2.8x close-up. ntd-theme.css now fits the photo to the
   screen; here, on touch only, a tap zooms to 2.5x centred on the tapped spot,
   drag pans (the viewer already scrolls), and a second tap fits it again.
   Closing the viewer resets it. */
(function () {
  if (window.ntdModalZoom) return;
  window.ntdModalZoom = true;

  var SCALE = 2.5;
  var lastPointer = '';

  function contentOf(el) {
    return el && el.closest('.product-media-modal__content');
  }

  function reset(scope) {
    if (!scope) return;
    scope.querySelectorAll('img.ntd-zoomed').forEach(function (img) {
      img.classList.remove('ntd-zoomed');
      img.style.width = '';
      img.style.maxWidth = '';
    });
    var content = scope.matches && scope.matches('.product-media-modal__content') ? scope : scope.querySelector('.product-media-modal__content');
    if (content) content.classList.remove('ntd-zoom-active');
  }

  document.addEventListener('pointerdown', function (e) {
    lastPointer = e.pointerType || '';
  }, true);

  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.product-media-modal__content > img');
    if (!img || lastPointer === 'mouse') return;
    var content = contentOf(img);
    if (img.classList.contains('ntd-zoomed')) {
      reset(content);
      return;
    }
    var r = img.getBoundingClientRect();
    var fx = (e.clientX - r.left) / r.width;
    var fy = (e.clientY - r.top) / r.height;
    reset(content);
    img.classList.add('ntd-zoomed');
    content.classList.add('ntd-zoom-active');
    img.style.maxWidth = 'none';
    img.style.width = Math.round(content.clientWidth * SCALE) + 'px';
    requestAnimationFrame(function () {
      content.scrollLeft = img.offsetLeft + fx * img.offsetWidth - content.clientWidth / 2;
      content.scrollTop = img.offsetTop + fy * img.offsetHeight - content.clientHeight / 2;
    });
  });

  // Any close (button, Escape, back) leaves the viewer un-zoomed next time.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.product-media-modal__toggle')) reset(e.target.closest('product-modal'));
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('product-modal').forEach(reset);
  });
})();
